import React from "react";
import classes from "./Contact.module.css";
// @ts-ignore
import P5Wrapper from "react-p5-wrapper";
import sketch from "../../sketches/Contact/Contact";
import ContactForm from "./ContactForm/ContactForm";
import { hideContactConfirm, hideContactForm, showContactForm } from "../../store/Contact/actions";
import { useDispatch } from "react-redux";
import ContactConfirm from "./ContactConfirm/ContactConfirm";

type ContactProps = {};

const Contact: React.FC<ContactProps> = (props) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(showContactForm());
        return () => {
            dispatch(hideContactForm());
            dispatch(hideContactConfirm());
        };
    }, [dispatch]);

    return (
        <div className={classes.Contact}>
            <P5Wrapper sketch={sketch} key="ContactSketch" />
            <ContactForm />
            <ContactConfirm />
        </div>
    );
};

export default Contact;
